import React from 'react'
import FileManagerMainPage from './components/FileManagerMainPage'

const FileManager = () => {
  return (
   <FileManagerMainPage/>
  )
}

export default FileManager